export default __webpack_public_path__ + "static/media/health.b178a75b.png";